/**
 * Message API — typed wrappers around legacy messageApi.js.
 */
import {
  sendMessage as legacySendMessage,
  getMessagesByProject as legacyGetMessagesByProject,
  deleteMessage as legacyDeleteMessage,
} from '../apiServices/messageApi';

import type { RawApiResponse } from './project';

export async function getMessagesByProject(projectId: string): Promise<RawApiResponse> {
  return legacyGetMessagesByProject(projectId);
}

export async function sendMessage(projectId: string, message: string): Promise<unknown> {
  return legacySendMessage(projectId, message);
}

export async function deleteMessage(messageId: string, projectId: string): Promise<unknown> {
  return legacyDeleteMessage(messageId, projectId);
}
